export default __webpack_public_path__ + "cec7039a252aa6b94cd0545e04fd2978.svg";